import React from 'react';
import { C } from '../data/constants';

// ─── BTN ─────────────────────────────────────────────────────────────────────
const BTN_STYLES = {
  green:  { background: C.green,  color: '#fff', boxShadow: `0 4px 0 #1A7A40`, border: 'none',                   marginTop: 0  },
  orange: { background: C.amber,  color: '#fff', boxShadow: `0 4px 0 #C07000`, border: 'none',                   marginTop: 0  },
  white:  { background: '#fff',   color: C.text, boxShadow: `0 4px 0 ${C.border}`, border: `2px solid ${C.border}`, marginTop: 8  },
};

export function Btn({ variant = 'green', onClick, children, style = {} }) {
  const base = BTN_STYLES[variant];
  return (
    <button
      onClick={onClick}
      style={{
        width: '100%', padding: '15px 0', borderRadius: 14,
        fontSize: 17, fontWeight: 700, cursor: 'pointer',
        fontFamily: 'Roboto, sans-serif', transition: 'transform .1s',
        ...base, ...style,
      }}
      onMouseDown={e => (e.currentTarget.style.transform = 'translateY(2px)')}
      onMouseUp={e   => (e.currentTarget.style.transform = '')}
      onMouseLeave={e => (e.currentTarget.style.transform = '')}
    >
      {children}
    </button>
  );
}

// ─── CHIP ─────────────────────────────────────────────────────────────────────
const CHIP_STYLES = {
  or: { background: '#FFF3E0', color: C.amber,  borderColor: '#FFD080' },
  gr: { background: '#E8F8F0', color: C.green,  borderColor: '#90DEB8' },
  bl: { background: '#E8F3FF', color: C.blue,   borderColor: '#90C0FF' },
  tl: { background: '#E0FBF5', color: '#008B70', borderColor: '#80DFC0' },
  pu: { background: '#F0ECFF', color: C.purple,  borderColor: '#C0A8FF' },
};

export function Chip({ type = 'or', children, style = {} }) {
  const cs = CHIP_STYLES[type];
  return (
    <span style={{
      display: 'inline-flex', alignItems: 'center', gap: 3,
      padding: '4px 9px', borderRadius: 20, fontSize: 12,
      fontWeight: 700, border: '2px solid',
      ...cs, ...style,
    }}>
      {children}
    </span>
  );
}

// ─── CARD ─────────────────────────────────────────────────────────────────────
export function Card({ children, style = {} }) {
  return (
    <div style={{
      background: '#fff', border: `2px solid ${C.border}`,
      borderRadius: 14, padding: 14, ...style,
    }}>
      {children}
    </div>
  );
}

// ─── XP BAR ──────────────────────────────────────────────────────────────────
export function XpBar({ pct = 62, label = 'Level 7 — Scholar of Sankore 📜', nextLabel = 'Wali of Al-Andalus 🕌', xpLeft = 760 }) {
  return (
    <Card style={{ marginBottom: 14 }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 6 }}>
        <div style={{ fontSize: 14, fontWeight: 700 }}>{label}</div>
        <div style={{ fontSize: 12, fontWeight: 700, color: C.teal }}>{pct}%</div>
      </div>
      <div style={{ height: 10, background: '#F0E8D8', borderRadius: 5, overflow: 'hidden', border: '2px solid #E0D0C0' }}>
        <div style={{ height: '100%', width: `${pct}%`, background: `linear-gradient(90deg,${C.teal},${C.teal2})`, borderRadius: 3 }} />
      </div>
      <div style={{ fontSize: 12, color: C.muted, marginTop: 4 }}>
        {xpLeft} XP to <strong>{nextLabel}</strong>
      </div>
    </Card>
  );
}

// ─── SECTION TITLE ────────────────────────────────────────────────────────────
export function STitle({ children }) {
  return (
    <div style={{ fontSize: 13, fontWeight: 700, letterSpacing: '.1em', textTransform: 'uppercase', color: C.muted, marginBottom: 8 }}>
      {children}
    </div>
  );
}

// ─── SPINNER ─────────────────────────────────────────────────────────────────
export function Spinner() {
  return (
    <span style={{
      display: 'inline-block', width: 16, height: 16,
      border: `2px solid #E0D0C0`, borderTopColor: C.amber,
      borderRadius: '50%', verticalAlign: 'middle', marginRight: 6,
      animation: 'spin .8s linear infinite',
    }} />
  );
}

// ─── BOTTOM NAV ──────────────────────────────────────────────────────────────
const NAV_ITEMS = [
  { id: 'home',        icon: '🏠', label: 'Home'    },
  { id: 'leaderboard', icon: '🏆', label: 'Ranks'   },
  { id: 'profile',     icon: '👤', label: 'Profile' },
  { id: 'badges',      icon: '🎖️', label: 'Titles'  },
];

export function BottomNav({ active, onTab }) {
  return (
    <div style={{ height: 64, background: '#fff', borderTop: `2px solid ${C.border}`, display: 'flex', flexShrink: 0 }}>
      {NAV_ITEMS.map(item => (
        <div
          key={item.id}
          onClick={() => onTab(item.id)}
          style={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 2, cursor: 'pointer' }}
        >
          <span style={{ fontSize: 22 }}>{item.icon}</span>
          <span style={{ fontSize: 10, fontWeight: 700, textTransform: 'uppercase', letterSpacing: '.05em', color: active === item.id ? C.amber : C.faint }}>
            {item.label}
          </span>
          {active === item.id && <div style={{ width: 5, height: 5, borderRadius: '50%', background: C.amber }} />}
        </div>
      ))}
    </div>
  );
}
